(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("tenantPaymentMethodResource", ["$resource", tenantPaymentMethodResource]);
    function tenantPaymentMethodResource($resource) {
        return $resource("/api/tenantPaymentMethod/:action", {}, {
            //getMonerisHostedPayPageViewModel: {
            //	method: "GET",
            //	params: { action: "monerisHostedPayPageViewModel" }
            //},
            //updateMonerisHosterPayPage: {
            //	method: "POST",
            //	params: { action: "monerisHostedPayPage" }
            //},
            getBamboraPaymentFormViewModel: {
                method: "GET",
                params: { action: "bamboraPaymentFormViewModel" }
            },
            updateBamboraPaymentForm: {
                method: "POST",
                params: { action: "bamboraPaymentForm" }
            },
            activate: {
                method: "POST",
                params: { action: "activate" }
            },
            deactivate: {
                method: "POST",
                params: { action: "deactivate" }
            },
            finalizePayPalExpressCheckout: {
                method: "POST",
                params: { action: "finalizePayPalExpressCheckout" }
            },
            getAffiniPayHostedPageViewModel: {
                method: "GET",
                params: { action: "affiniPayHostedPageViewModel" }
            },
            updateAffiniPayHostedPage: {
                method: "POST",
                params: { action: "affiniPayHostedPage" }
            },
            getBamboraCustomCheckoutViewModel: {
                method: "GET",
                params: { action: "bamboraCustomCheckoutViewModel" }
            },
            updateBamboraCustomCheckout: {
                method: "POST",
                params: { action: "bamboraCustomCheckout" }
            },
            getStripeCheckoutView: {
                method: "GET",
                params: { action: "stripeCheckoutView" }
            },
            updateStripeCheckoutView: {
                method: "POST",
                params: { action: "stripeCheckoutView" }
            }
        });
    }
}());
